import _extends from '/d02/applications/www/frontend/cashback.wmr.ru/releases/232/node_modules/babel-runtime/helpers/extends';
//
//
//
//
//
//

import axios from 'axios';

export default {
    name: 'tiny-mce',
    props: {
        id: {
            type: String,
            default: 'editor'
        },
        plugins: {
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        toolbar: {
            default: ''
        },
        menubar: {
            default: ''
        },
        uploadDir: {
            default: ''
        },
        uploadBase: {
            default: ''
        },
        otherProps: {
            default: ''
        },
        baseURL: {
            type: String,
            default: ''
        }
    },
    mounted: function mounted() {
        var _this = this;

        var self = this;
        tinymce.baseURL = this.baseURL;
        tinymce.init(_extends({
            selector: '#' + this.id,
            toolbar: this.toolbar,
            branding: false,
            image_title: true,
            automatic_uploads: true,
            file_picker_types: 'image',
            images_upload_handler: function images_upload_handler(blobInfo, success, failure) {
                var canvas = document.createElement('canvas');
                var context = canvas.getContext('2d');
                var pngUrl = void 0;
                if (blobInfo.blob()) {
                    var temp = blobInfo.blob();
                    var FR = new FileReader();
                    FR.onload = function (e) {
                        var img = new Image();
                        img.onload = function () {
                            canvas.width = img.width;
                            canvas.height = img.height;
                            context.drawImage(img, 0, 0);
                            pngUrl = canvas.toDataURL('image/jpeg');

                            axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
                            var fd = new FormData();
                            fd.append('image', pngUrl);
                            fd.append('extension', '.jpg');
                            axios.post(self.uploadBase + self.uploadDir, fd).then(function (res) {
                                var temp = self.uploadBase + res.data;
                                success(temp);
                                self.$emit('input', tinymce.activeEditor.getContent());
                            }).catch(function (error) {
                                console.warn(error);
                            });
                        };
                        img.src = e.target.result;
                    };
                    FR.readAsDataURL(temp);
                }
            },
            file_picker_callback: function file_picker_callback(cb, value, meta) {
                var input = document.createElement('input');
                input.setAttribute('type', 'file');
                input.setAttribute('accept', 'image/*');

                input.onchange = function () {
                    var file = this.files[0];
                    var reader = new FileReader();
                    reader.onload = function () {
                        var id = 'blobid' + new Date().getTime();
                        var blobCache = tinymce.activeEditor.editorUpload.blobCache;
                        var base64 = reader.result.split(',')[1];
                        var blobInfo = blobCache.create(id, file, base64);
                        blobCache.add(blobInfo);
                        cb(blobInfo.blobUri(), { title: file.name });
                    };
                    reader.readAsDataURL(file);
                };

                input.click();
            },
            menubar: this.menubar,
            plugins: ['paste', 'link', 'table', 'image', 'anchor', 'code', 'hr', 'imagetools'],
            init_instance_callback: function init_instance_callback(editor) {
                editor.on('KeyUp', function (e) {
                    _this.$emit('input', editor.getContent());
                });

                editor.on('Change', function (e) {
                    _this.$emit('input', editor.getContent());
                });

                editor.setContent(_this.value);
            }
        }, this.otherProps));
    },
    updated: function updated() {
        // tinymce.get(this.id).setContent(this.value);
    },
    destroyed: function destroyed() {
        tinymce.get(this.id).destroy();
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/d02/applications/www/frontend/cashback.wmr.ru/releases/232/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue2-tinymce-adapter/TinyMce.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/d02/applications/www/frontend/cashback.wmr.ru/releases/232/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue2-tinymce-adapter/TinyMce.vue
// module chunks = 152